import { el, awaitRedraw } from "@dhx/ts-common/dom";
import { Calendar } from "@dhx/ts-calendar";
import { Popup } from "@dhx/ts-popup";
import { NavigationBarEvents } from "../types";

function onBlur(events, id) {
	events.fire(NavigationBarEvents.inputBlur, [id]);
}

function onFocus(events, id, popup, e) {
	awaitRedraw().then(() => popup.show(e.target));
	events.fire(NavigationBarEvents.inputFocus, [id]);
}

export function datePicker(item, events, widgetName: string) {
	let isInit;
	let calendar;
	let popup;

	if (!isInit) {
		popup = new Popup();
		calendar = new Calendar(null, {
			dateFormat: item.dateFormat || "%d/%m/%y",
			value: item.value,
			css: "dhx_widget--bordered",
		});

		popup.attach(calendar);

		calendar.events.on("change", () => {
			popup.hide();
			events.fire(NavigationBarEvents.inputChange, [item.id, calendar.getValue()]);
		});
		isInit = true;
	}

	return el(
		".dhx_form-group.dhx_form-group--no-message-holder" +
			(item.hiddenLabel ? ".dhx_form-group--label_sr" : ".dhx_form-group--inline") +
			`.dhx_${widgetName}__input`,
		{
			style: {
				width: item.width ? item.width : "200px",
			},
			role: "presentation",
		},
		[
			item.label &&
				el(
					"label.dhx_label",
					{
						for: item.id,
						style: {
							maxWidth: item.hiddenLabel ? null : "100%",
						},
					},
					item.label
				),
			el(
				".dhx_input__wrapper",
				{
					role: "presentation",
				},
				[
					el("input.dhx_input", {
						id: item.id,
						placeholder: item.placeholder,
						class: item.icon ? "dhx_input--icon-padding" : "",
						value: calendar.getValue(),
						disabled: item.disabled,
						onblur: [onBlur, events, item.id],
						onfocus: [onFocus, events, item.id, popup],
						"data-dhx-id": item.id,
						readOnly: true,
						_hooks: {
							didInsert(node) {
								if (events) {
									events.fire(NavigationBarEvents.inputCreated, [item.id, node.el]);
								}
							},
						},
						_key: item.id,
						"aria-label":
							item.label ||
							item.helpMessage ||
							`type ${item.placeholder ? "text like " + item.placeholder : "text"}`,
					}),
					item.icon
						? el(".dhx_input__icon", {
								class: item.icon,
								"aria-hidden": "true",
						  })
						: null,
				]
			),
		]
	);
}
